export default __webpack_public_path__ + "static/media/harvey3.798dbb80.jpg";